import { mutatorAction } from 'satcheljs';
import type { TableView } from 'owa-mail-list-store';

export const setRowKeyPendingSelectionMutator: (
    tableView: TableView,
    rowKey: string | null
) => void = mutatorAction(
    'setRowKeyPendingSelectionMutator',
    (tableView: TableView, rowKey: string | null): void => {
        if (tableView) {
            tableView.rowKeyPendingSelection = rowKey;
        }
        return;
    }
);
